<template>
<modal name="roxx-dialog"
  id="roxx-dialog"
  :adaptive="true"
  :scrollable="true"
  height="auto">
  <div >
    <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading">
      <el-button @click="closeDialog"
        icon="el-icon-circle-close-outline"
        style="font-size: 2rem;"
        type="text"></el-button>
    </div>
    <div style="display: inline-block;min-width: 100%;text-align:center;" >
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;"> 
          もうすぐで完了するよ！
        </p>
        <p style="font-size: 120%;"> 
          今作成した履歴書をもとに<br/>
          プロが好条件の勤め先をご紹介します！
        </p>
        <br>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/roxx_yagish_logo.png" style="width:100%" >
        </p>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <br/>
        <p style="font-size: 140%;"> 
          ご同意いただいた方には追って連絡がいきますので、ご確認お願いいたします！
        </p>
      </div>
      <br/>
    <div style="display: inline-block;min-width: 100%;text-align:center;">
      <p>
        Yagishの<router-link id="footer-link-terms" :to="{name: 'termsPage'}" target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{name: 'policyPage'}" target="_blank">個人情報保護方針</router-link>
        <br/>
        キャリアシの<a href="https://careerassist.jp/terms/" target="_blank">利用規約</a>、<a href="https://roxx.co.jp/policy/privacy" target="_blank">個人情報保護方針</a>
      </p>
    </div>
    <br/>
    <div style="display: inline-block;min-width: 100%;text-align:center;">
      <p style="font-size: 140%;"> 
        <el-checkbox v-model="isAgree" style="-moz-transform:	scale(1.4);-webkit-transform:	scale(1.4);transform:		scale(1.4);">規約に同意して無料相談を希望する</el-checkbox>
      </p>
    </div>
    <br/>
    <div class="text-center">
      <el-button id="send-roxx-api" type="success" v-if="isSended == false" style="background-color:#E3165C;border-color:#E3165C;font-size: 140%;"
        @click="$eventHub.$emit('send-roxx-consult');">　同意する　</el-button>
      <el-button id="send-roxx-api" type="success" v-if="isSended == true"
        @click="closeDialog();">送信しました</el-button>
    </div>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="$deviceLib.isApple">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/check_icon.png" style="width:40px" >アプリをダウンロードしていつでも編集・PDFをメール送信できるように準備しよう！
        </p>
        <div class="text-center">
          <button type="button" class="el-button el-button--success" id="send-adtop-pdf"  style="background-color:#0F9934;border-color:#0F9934;"
          onClick="window.open('https://apple.co/3GJbCBo', '_blank');" ><span>ヤギッシュアプリを確認！</span></button>
        </div>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;" v-else-if="$deviceLib.isAndroid">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/check_icon.png" style="width:40px" >アプリをダウンロードしていつでも編集・PDFをメール送信できるように準備しよう！
        </p>
        <div class="text-center">
          <button type="button" class="el-button el-button--success" id="send-adtop-pdf"  style="background-color:#0F9934;border-color:#0F9934;"
          onClick="window.open('https://bit.ly/3O01VRv', '_blank');" ><span>ヤギッシュアプリを確認！</span></button>
        </div>
      </div>
    </div>
  </div>
</modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>

<script>
export default {
  components: {
  },
  data: function () {
    return {
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      previewHtml: '',
      gradeYear: 0,
      permissionType: 1,
      isSended:false,
      fullscreenLoading:false,
      username:'',
      baite_title:'バイト',
      isAgree:false,
      inputEmail:'',
      foreignStudent:false,
      isRandom:true
    }
  },
  created : function(){
    console.error('newgrade created')
    const app = this
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    pdfFormData: function () {
      const formData = new FormData()
      formData.append('app_html', this.cleanedPreviewHtml)
      formData.append('pdf_option', 'A4')
      return formData
    }
  },
  methods: {
    openRoxxDialog: function (id, html, email) {
      this.formatid = id
      this.previewHtml = html.$el.innerHTML
      this.inputEmail = email
      this.$modal.show('roxx-dialog')
      this.clearLocalStorageConfirmVisible = false
      const app = this

      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('dialog_name', 'roxx_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('site_flag', 'd')
      formData.append('app_flag', '')
      this.$axios.post(this.$varuna.endPoints.displayDialog, formData, {timeout: 60000})
      this.$iterateStorage(function (value, key, iterationNumber) {
          //console.log all the kay/value pairs
          if (key === 'basicData') {
            app.username = value.lastName + '_' + value.firstName
          }
      }, function (err) {
          if (!err) {
              console.log('Iteration has completed');
          }
      })
    },
    closeDialog: function () {
      this.$modal.hide('roxx-dialog')
      this.clearLocalStorageConfirmVisible = false
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.formatid}${dateString}.${ext}`
    },
    sendRoxxConsult: async function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      const app = this
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('dialog_name', 'roxx_dialog')
      formData.append('permission_type', this.permissionType)
      if ((!this.$firebase.user.email && this.inputEmail) || 
        (this.$firebase.user.email.indexOf('@privaterelay.appleid.com') > 0 && this.inputEmail)) {
        formData.append('inputemail', this.inputEmail)
      }
      formData.append('yaginame', this.username)
      formData.append('app_flag', '')
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('reqflg', '2')
      this.$axios
        .post(this.$varuna.endPoints.sendDataRoxx, formData, {timeout: 60000})
        .then(function (response) {
          app.isSended = true
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `担当者からあなたのメールアドレスに連絡が届くことがあります！`,
            type: 'info'
          })
        })
        .catch(function (error) {
          app.$message({
            duration: 0,
            showClose: true,
            message: '応募に失敗しました。入力内容を確認して再度ご応募ください',
            type: 'error'
          })
        }).finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('send-roxx-consult', this.sendRoxxConsult)
    this.$eventHub.$on('open-roxx-dialog', this.openRoxxDialog)
    this.$eventHub.$on('popstate', this.closeDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('send-roxx-consult', this.sendRoxxConsult)
    this.$eventHub.$off('open-roxx-dialog', this.openRoxxDialog)
    this.$eventHub.$off('popstate', this.closeDialog)
  }
}
</script>
